import styled from "styled-components";

export const Main = styled.div`
   display: flex;
   flex-direction: column;
   box-sizing: border-box;
   position: fixed;
   top: 0;
   right: 0;
   visibility: hidden;
   background-color: #fff;
   box-shadow: 0 10px 24px rgba(15, 23, 42, 0.14), 0 4px 10px rgba(15, 23, 42, 0.09);
   width: 400px;
   max-width: 100vw;
   height: 100vh;
   z-index: 9999999;
   padding: 50px 30px 30px;
   transform: translateX(100%);
   transition: transform 0.45s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.45s;

   &.show {
      transform: translateX(0);
      visibility: visible;
   }

   &.ai-agent {
      left: 50%;
      right: auto;
      top: 50%;
      width: min(94vw, 1180px);
      height: min(88vh, 900px);
      max-height: 88vh;
      border: 1px solid #dbe4f0;
      border-radius: 20px;
      background: #f8fbff;
      padding: 12px;
      box-shadow: 0 24px 56px rgba(15, 23, 42, 0.22), 0 8px 20px rgba(15, 23, 42, 0.12);
      transform: translate(-50%, calc(-50% + 20px)) scale(0.98);
      opacity: 0;
      visibility: hidden;
      transition: transform 0.3s cubic-bezier(0.2, 0.7, 0.2, 1), opacity 0.3s ease, visibility 0.3s;
   }

   &.ai-agent.show {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
      visibility: visible;
   }
   .close {
      position: absolute;
      top: 15px;
      left: 15px;
      opacity: 0.65;
      cursor: pointer;
      transition: all .2s ease-in-out;
      z-index: 1;

      &:hover {
         opacity: 0.9;
      }
   }

   &.ai-agent .close {
      left: auto;
      right: 14px;
      top: 14px;
      background: #ffffff;
      border: 1px solid #dbe4f0;
      border-radius: 10px;
      padding: 4px;
      width: 28px;
      height: 28px;
   }
   .empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      opacity: 0.5;
   }
   .scroll {
      overflow: auto;
      height: 100%;
      min-height: 0;
      flex: 1;
      width: 100%;
   }

   &.ai-agent .scroll {
      overflow: hidden;
      display: flex;
      width: 100%;
      margin-top: 24px;
   }

   &.ai-agent .scroll > * {
      flex: 1 1 auto;
      min-width: 0;
      min-height: 0;
      width: 100%;
   }
`;